import { render, staticRenderFns } from "./HomeSquare.vue?vue&type=template&id=d736eb82&scoped=true&"
import script from "./HomeSquare.vue?vue&type=script&lang=js&"
export * from "./HomeSquare.vue?vue&type=script&lang=js&"
import style0 from "./HomeSquare.vue?vue&type=style&index=0&id=d736eb82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d736eb82",
  null
  
)

export default component.exports